import { render, staticRenderFns } from "./popupInfo.vue?vue&type=template&id=6fc315bd&scoped=true&lang=true&"
import script from "./popupInfo.vue?vue&type=script&lang=js&"
export * from "./popupInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc315bd",
  null
  
)

export default component.exports